import { render, staticRenderFns } from "./SectionsMaintenanceComponent.vue?vue&type=template&id=2919f4d3&scoped=true"
import script from "./SectionsMaintenanceComponent.vue?vue&type=script&lang=js"
export * from "./SectionsMaintenanceComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2919f4d3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2919f4d3')) {
      api.createRecord('2919f4d3', component.options)
    } else {
      api.reload('2919f4d3', component.options)
    }
    module.hot.accept("./SectionsMaintenanceComponent.vue?vue&type=template&id=2919f4d3&scoped=true", function () {
      api.rerender('2919f4d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/customer-insigths/components/somos1/SectionsMaintenanceComponent.vue"
export default component.exports